import { z } from 'zod'
import { permissionCodeSchema, permissionDefinitions, type PermissionCode } from '../authorization/contract.ts'
import { creatorListQueryShape } from '../list-query/contract.ts'

export const botSupportedPermissions: readonly PermissionCode[] = [
  'business.read',
  'customer.read',
  'order.rental.read',
  'order.service.read',
  'bill.read',
  'bill.generate',
  'bill.issue',
  'bill.group.read',
  'bill.group.create',
  'bill.group.issue',
  'bill.group.send'
]
export const botPermissionDefinitions = permissionDefinitions.filter(
  (definition) =>
    definition.kind === 'operation' && !definition.superAdminOnly && botSupportedPermissions.includes(definition.code)
)
export const botListSchema = z.object({
  ...creatorListQueryShape,
  current: z.number().int().positive().default(1),
  pageSize: z.number().int().positive().max(100).default(20),
  id: z.uuid().optional(),
  keyword: z.string().trim().max(100).optional(),
  isEnabled: z.boolean().optional(),
  sortField: z.enum(['createdAt', 'name']).default('createdAt'),
  sortOrder: z.enum(['asc', 'desc']).default('desc')
})
export const botCreateSchema = z.strictObject({
  kind: z.enum(['customer', 'internal']).default('customer'),
  name: z.string({ error: '请输入机器人名称' }).trim().min(1, '请输入机器人名称').max(100),
  remark: z.string().trim().max(1000).nullable().optional(),
  channelId: z.string().trim().min(1).max(100).optional(),
  wecomBotId: z.string({ error: '请输入企微机器人 ID' }).trim().min(1, '请输入企微机器人 ID').max(255),
  secret: z.string({ error: '请输入企微机器人密钥' }).trim().min(1, '请输入企微机器人密钥').max(4096)
})
export const botVersionSchema = z.object({ id: z.uuid(), expectedVersion: z.number().int().positive() })
export const botUpdateSchema = botVersionSchema.extend({
  name: botCreateSchema.shape.name,
  remark: botCreateSchema.shape.remark,
  wecomBotId: botCreateSchema.shape.wecomBotId.optional(),
  secret: botCreateSchema.shape.secret.optional()
})
export const botStatusSchema = botVersionSchema.extend({ isEnabled: z.boolean() })
export const botPermissionsSchema = botVersionSchema.extend({
  permissionCodes: z.array(permissionCodeSchema).max(100),
  catalogVersion: z.string()
})
export const botSecretSchema = botVersionSchema
  .extend({
    wecomBotId: botCreateSchema.shape.wecomBotId.optional(),
    secret: botCreateSchema.shape.secret.optional()
  })
  .refine((value) => value.wecomBotId !== undefined || value.secret !== undefined, '请填写企微机器人 ID 或密钥')
export const botTrainingSchema = botVersionSchema.extend({ trainingEnabled: z.boolean() })
export const trainingStartSchema = z.strictObject({
  botId: z.uuid(),
  customerId: z.number().int().positive(),
  live: z.boolean().default(false),
  bindingId: z.number().int().positive().optional()
})
export type BotListInput = z.infer<typeof botListSchema>
